import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import Choices from 'choices.js';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { DEFAULT_MAX_FILE_SIZE } from '../../consts/default-max-file-size.const';
import { API_VERSIONS } from '../../consts/api-versions.const';

@Component({
  selector: 'app-send-email-popup',
  templateUrl: './send-email-popup.component.html',
  styleUrls: ['./send-email-popup.component.css'],
})
export class SendEmailPopupComponent implements OnInit {
  achieve: any = 35;
  // showSendEmailPopUp:boolean = false;
  isLoading: boolean = false;
  claimDetails: any;
  serverErrorFetch: any = '';
  delivery: any;
  selectMessage: any;
  // when canceling popup from outside of cancel button open discard popup
  @ViewChild('messageComponent', { static: false }) messageComponent: any;
  loadingConfirm: boolean = false;

  sendMailForm!: FormGroup;
  claimId!: number | null;

  fileInput: any;
  isUploaded: boolean = false;
  formDataPayLoad: any = new FormData();
  fileSize: any = DEFAULT_MAX_FILE_SIZE;
  photoAllowedExt: any = [
    '.pdf',
    '.docx',
    '.doc',
    '.txt',
    '.xls',
    '.xlsm',
    '.xlsx',
  ];
  @ViewChild('attachedFile') attachedFileEle!: ElementRef;
  fileName: any;
  loadingSubmit: boolean = false;
  userObject: any = this._auth.getUserObj();

  @Input('showSendEmailPopUp') showSendEmailPopUp: boolean = false;
  @Output() emitCloseSendEmailPopup = new EventEmitter<any>();
  @Input('receiversArray') receiversArray: any = [];
  @Input('ccArray') ccArray: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private _api: HttpService,
    private notificationService: NotificationsService,
    private errHandle: ErrorHandlingService,
    private _auth: AuthService,
    public _pService: PermissionsService,
  ) {}

  ngOnInit(): void {
    this.initializeVariables();
  }

  initializeVariables() {
    this.delivery = [
      { name: 'Yes', key: '1' },
      { name: 'No', key: '0' },
    ];
    this.sendMailForm = new FormGroup({
      sender: new FormControl('', []),
      receivers: new FormControl('', [Validators.required]),
      validationErrRec: new FormControl('', []),
      cc: new FormControl('', []),
      validationErrCC: new FormControl('', []),
      delivery_acknowledge: new FormControl('', [Validators.required]),
      subject: new FormControl('', [Validators.required]),
      body: new FormControl('', [Validators.required]),
      attachFile: new FormControl('', []),
    });
  }

  ngOnChanges() {
    if (this.showSendEmailPopUp) {
      this.openSendMail();
    }
  }

  accepted() {
    this.messageComponent.close();
    this.emitCloseSendEmailPopup.emit(true);
    this.sendMailForm.reset();
  }

  rejected() {
    this.messageComponent.close();
  }

  closeModalOutside(event: any) {
    if (this.sendMailForm.dirty) {
      this.messageComponent.open();
    } else {
      this.accepted();
    }
  }

  uploadImage(event: any) {
    const file = event.target.files[0];
    //check if file exist
    if (file) {
      //if valid file load in design
      if (this.sendMailForm.controls['attachFile'].valid) {
        this.formDataPayLoad?.delete('attached_file');
        this.isUploaded = true;
        const reader = new FileReader();
        this.formDataPayLoad.append('attached_file', file);
        reader.readAsDataURL(file);
        reader.onload = (e: any) => {
          this.fileName = file?.name;
          // this.showConfirmPopup = true;
        };
      } else {
        // reset all attributes
        this.isUploaded = false;
        this.sendMailForm.controls['attachFile'].markAsTouched();
      }
    } else {
    }
  }

  deleteFile() {
    this.isUploaded = false;
    this.fileName = '';
    this.sendMailForm.controls['attachFile'].reset();
  }

  fetchFile() {
    this.attachedFileEle.nativeElement.click();
  }

  onHide() {
    this.sendMailForm.reset();
    this.isUploaded = false;
    this.fileName = '';
    this.sendMailForm.markAsUntouched();
  }

  onChangeChoices(e: any, isReceiver: boolean = true) {
    if (isReceiver) {
      this.sendMailForm.controls['validationErrRec'].setValue('');
    } else {
      this.sendMailForm.controls['validationErrCC'].setValue('');
    }
  }

  save() {
    if (this.sendMailForm.invalid || !this.sendMailForm.dirty) {
      this.sendMailForm.markAllAsTouched();
      return;
    }

    this.clearFormData();
    this.sendMailForm.value.receivers?.forEach(
      (receiver: any, index: number) => {
        this.formDataPayLoad.append(`receivers[${index}]`, receiver?.email);
      },
    );

    if (this.sendMailForm.value.cc) {
      this.sendMailForm.value.cc?.forEach((cc: any, index: number) => {
        this.formDataPayLoad.append(`cc[${index}]`, cc?.email);
      });
    }

    this.formDataPayLoad.append(`subject`, this.sendMailForm.value.subject);
    this.formDataPayLoad.append(`body`, this.sendMailForm.value.body);
    this.formDataPayLoad.append(
      `delivery_acknowledge`,
      this.sendMailForm.value.delivery_acknowledge?.key,
    );

    this.loadingSubmit = true;
    this._api.postReq(`/send-general-email`, this.formDataPayLoad).subscribe(
      (res) => {
        this.loadingSubmit = false;
        this.notificationService.success('', res?.message);
        this.emitCloseSendEmailPopup.emit(false);
        this.onHide();
      },
      (err) => {
        this.errHandle.errorHandling(err);
        this.loadingSubmit = false;
      },
    );
  }

  validateEmail(email: any) {
    const emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return emailRegex.test(email);
  }

  clearFormData() {
    // Get an array of all keys in the FormData object
    const keys = Array.from(this.formDataPayLoad.keys());

    // Iterate over the keys and delete each one
    keys.forEach((key) => {
      if (key != 'attached_file') {
        this.formDataPayLoad.delete(key);
      }
    });
  }

  openSendMail() {
    this.showSendEmailPopUp = true;
    this.sendMailForm.controls['sender'].setValue(this.userObject?.email);
    // setTimeout(() => {
    //   this.addNewChoice('receiver')
    //   this.addNewChoice('cc')
    // }, 200)
  }

  addNewChoice(choiceName: string) {
    const element: any = document.getElementById(
      `choices-multiple-${choiceName}`,
    );
    const choiceField = new Choices(element, {
      items: [],
      choices: [],
      addItems: true,
      addItemFilter: null,
      removeItems: true,
      removeItemButton: true,
      allowHTML: true,
      duplicateItemsAllowed: false,
      delimiter: ',',
      paste: true,
      searchEnabled: true,
      searchChoices: true,
      searchFloor: 1,
      searchResultLimit: 4,
      searchFields: ['label', 'value'],
      position: 'auto',
      resetScrollPosition: true,
      shouldSort: true,
      shouldSortItems: false,
      placeholder: true,
      placeholderValue: null,
      searchPlaceholderValue: null,
      prependValue: null,
      appendValue: null,
      renderSelectedChoices: 'always',
      loadingText: 'Loading...',
      noResultsText: 'No results found',
      noChoicesText: 'No choices to choose from',
      itemSelectText: 'Press to select',
      maxItemCount: -1,
    });

    if (choiceName == 'cc') {
      this.sendMailForm.controls['cc'].setValue(choiceField);
    } else {
      this.sendMailForm.controls['receivers'].setValue(choiceField);
    }
  }

  suggestions: any[] = [];
  usersObs$: any;
  onQueryChange(e: any) {
    if (e?.query.trim() === '') {
      this.suggestions = [];
      return;
    }

    if (e?.query?.length < 2) {
      this.suggestions = [];
      return;
    }

    if (this.usersObs$) {
      this.usersObs$.unsubscribe();
    }

    this.usersObs$ = this._api.getReq(`/${API_VERSIONS.USERS}/users?search=${e?.query}`).subscribe(
      (res: any) => {
        this.suggestions = res?.data ? res?.data : [];
      },
      (err) => {
        this.errHandle.errorHandling(err);
        this.suggestions = [];
      },
    );
  }

  onSelected(e: any) {
    this.suggestions = [];
  }
}
